import React from "react";
import HOC from "../../components/HOC";
import CreateUser from "../../components/screen/userManagement/CreateUser";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import { Breadcrumbs, Link, ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";

const TambahPengguna = () => {
  return (
    <div className="">
      <PageTemplate
        header="Tambah Pengguna"
        mainComponent={
          <ThemeProvider theme={theme}>
            <div className="text-[12px]">
              <CreateUser />
            </div>
          </ThemeProvider>
        }
        pageRole={6}
        breadcrumb={
          <Breadcrumbs sx={{ color: "#1761FD", marginBottom: 2, fontSize: 12 }}>
            <Link
              href="/user-management"
              underline="hover"
              color="#1761FD"
              sx={{ color: "#1761FD" }}
            >
              User Management
            </Link>
            <Link
              href="/user-management/create-user"
              color="#1761FD"
              sx={{ color: "#1761FD" }}
              underline="none"
            >
              Create User
            </Link>
          </Breadcrumbs>
        }
      />
    </div>
  );
};

export default HOC(TambahPengguna);
